import { rest } from "msw";
import { apiUrl } from "features/configure";
import { referral, x, notification } from "./data/MockCampaignPerformance";
import _ from "lodash";

const getReferrerProgram = rest.get(
  `${apiUrl}/api/referral/:entityName/program`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(referral.program));
  }
);
const getReferrerDetail = rest.get(
  `${apiUrl}/api/referral/:entityName/program/detail`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(referral.detail));
  }
);

const getXList = rest.get(
  `${apiUrl}/api/x/:entityName/campaign`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(x.list));
  }
);

const getXFeed = rest.get(
  `${apiUrl}/api/x/:entityName/campaign/:campaignId/feed`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(x.feed));
  }
);
const getXPerformance = rest.get(
  `${apiUrl}/api/x/:entityName/campaign/:campaignId/performance`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(x.performance));
  }
);
const getXDetail = rest.get(
  `${apiUrl}/api/x/:entityName/campaign/:campaignId/detail`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(x.detail));
  }
);
const getNotificationList = rest.get(
  `${apiUrl}/api/notification/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ notifications: notification.list }));
  }
);
const getNotificationReach = rest.post(
  `${apiUrl}/api/notification/groups/estimatedReach`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(notification.reach));
  }
);
const getNotificationDetail = rest.get(
  `${apiUrl}/api/notification/:entityName/:notificationId`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(notification.detail));
  }
);

const getNotificationOverview = rest.get(
  `${apiUrl}/api/notification/performance/:entityName/overview`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(notification.overview));
  }
);

const getNotificationPerformanceTable = rest.get(
  `${apiUrl}/api/notification/performance/:entityName/table`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(notification.performanceTable),
      ctx.set("x-total-count", "4")
    );
  }
);

export const campaignMocks = [
  getReferrerProgram,
  getReferrerDetail,
  getXList,
  getXFeed,
  getXPerformance,
  getXDetail,
  getNotificationList,
  getNotificationDetail,
  getNotificationReach,
  getNotificationOverview,
  getNotificationPerformanceTable,
];
